import React, { useEffect, useState } from "react";
import { Wrapper } from "../../components/Wrapper";
import { PageTitle } from "../../components/PageTitle";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Notification } from "../../utils/Notification";
import { useTranslation } from "react-i18next";
import { Button } from "../../components/Button";
import { MultilangTextInput } from "../../components/Form/MultilangTextInput";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Preload } from "../../components/Preload";
import { Selected } from "../../components/Form/Selected";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import i18next from "i18next";
import { GET_POINT } from "../../graphql/Queries/PointQuery";
import { TextInput } from "../../components/Form/TextInput";
import { POINT_TYPE } from "../../utils/Dictionaries";
import { MODIFY_POINT } from "../../graphql/Mutations/PointMutation";
import { GET_CITIES_FILTER } from "../../graphql/Queries/CityQuery";
import { GET_AREAS_FILTER } from "../../graphql/Queries/AreaQuery";
import { CityFormComponent } from "../../components/forms/CityFormComponent";
import { toast } from "react-toastify";
import { Col, Modal } from "react-bootstrap";
import { Loader } from "@googlemaps/js-api-loader";
import axios from "axios";

export const FormPoint = ({ url }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  let location = useLocation();
  const id = location.state ? location.state.id : null;
  let [searchParams, setSearchParams] = useSearchParams();
  const [modify] = useMutation(MODIFY_POINT);
  const { data } = useQuery(GET_POINT, {
    variables: {
      id: Number(searchParams.get("id")),
      lang: i18next.language,
    },
    fetchPolicy: "no-cache",
  });
  const formik = useFormik({
    initialValues: {
      id: 0,
      name: {
        ru: "",
        az: "",
        en: "",
      },
      address: {
        ru: "",
        az: "",
        en: "",
      },
      lat: "",
      lng: "",
      type: 1,
      city_id: null,
      area_id: null,
    },
    validationSchema: Yup.object({
      name: Yup.object().shape({
        ru: Yup.string().required(t("Объязательное поле")),
      }),
      address: Yup.object().shape({
        ru: Yup.string().required(t("Объязательное поле")),
      }),
      lat: Yup.number().required(t("Объязательное поле")),
      lng: Yup.number().required(t("Объязательное поле")),
      city_id: Yup.number().required(t("Объязательное поле")),
    }),
    onSubmit: (values) => {
      setLoading(true);
      modify({
        variables: {
          id: Number(values.id),
          name: JSON.stringify(values.name),
          address: JSON.stringify(values.address),
          lat: String(values.lat),
          lng: String(values.lng),
          type: values.type,
          city_id: Number(values.city_id),
          area_id: Number(values.area_id),
        },
      })
        .then((response) => {
          navigate(url);
          Notification(t("Все хорошо!"), "success");
        })
        .catch((error) => {
          Notification(error);
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });
  const [getCity] = useLazyQuery(GET_CITIES_FILTER);
  const [getArea] = useLazyQuery(GET_AREAS_FILTER);
  const [arrCity, setArrCity] = useState([]);
  const [arrArea, setArrArea] = useState([]);
  const [showModal, toggleModal] = useState("");

  const loader = new Loader({
    apiKey: process.env.REACT_APP_GOOGLE_MAP_KEY,
    version: "weekly",
    libraries: ["places", "marker"],
  });

  const mapOptions = {
    center: {
      lat: 40.401006011050455,
      lng: 49.85458884979265,
    },
    zoom: 16,
  };

  useEffect(() => {
    getCity({
      variables: {
        lang: i18next.language,
      },
    })
      .then((resp) => {
        setArrCity(resp.data.cities);
      })
      .catch((error) => {
        toast.error(error.message);
      });
  }, []);

  useEffect(() => {
    if (data && data.point[0]) {
      data.point[0].name.map((dic) => {
        formik.setFieldValue(`name.${dic.lang}`, dic.value);
      });
      data.point[0].address.map((dic) => {
        formik.setFieldValue(`address.${dic.lang}`, dic.value);
      });
      formik.setFieldValue("id", data.point[0].id);
      formik.setFieldValue("lat", data.point[0].lat);
      formik.setFieldValue("lng", data.point[0].lng);
      formik.setFieldValue("type", data.point[0].type);
      formik.setFieldValue("city_id", String(data.point[0].city_id));
      formik.setFieldValue("area_id", String(data.point[0].area_id));
      if (data.point[0].city_id) {
        getArea({
          variables: {
            city_id: Number(data.point[0].city_id),
            lang: i18next.language,
          },
        })
          .then((resp) => {
            setArrArea(resp.data.areas);
          })
          .catch((error) => {
            toast.error(error.message);
          });
      }
    }
  }, [data]);

  if (!data) {
    return <Preload />;
  }

  return (
    <Wrapper>
      <PageTitle
        title={id === null ? "Добавить ориентир" : "Редактировать ориентир"}
        breadcrumbs={[
          {
            slug: url,
            name: "Ориентиры",
          },
        ]}
      />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <form className="row" onSubmit={formik.handleSubmit}>
                <div className="col-md-6">
                  <MultilangTextInput
                    label={"Название"}
                    value={formik.values.name}
                    onChange={(text, lang) => {
                      formik.setFieldValue(`name.${lang}`, text);
                    }}
                    onBlur={formik.handleBlur}
                    error={formik.errors.name}
                    name={"name"}
                  />
                </div>
                <div className="col-md-6">
                  <MultilangTextInput
                    label={"Адрес"}
                    value={formik.values.address}
                    onChange={(text, lang) => {
                      formik.setFieldValue(`address.${lang}`, text);
                    }}
                    onBlur={formik.handleBlur}
                    error={formik.errors.address}
                    name={"name"}
                  />
                </div>
                <div className="col-md-4">
                  <TextInput
                    label={"Lat"}
                    value={formik.values.lat}
                    onChange={(event) => {
                      formik.setFieldValue(`lat`, event.target.value);
                    }}
                    onBlur={formik.handleBlur}
                    error={formik.errors.lat}
                    name={"lat"}
                  />
                </div>
                <div className="col-md-4">
                  <TextInput
                    label={"Lng"}
                    value={formik.values.lng}
                    onChange={(event) => {
                      formik.setFieldValue(`lng`, event.target.value);
                    }}
                    onBlur={formik.handleBlur}
                    error={formik.errors.lng}
                    name={"lng"}
                  />
                </div>
                <Col md={4}>
                  <button
                    type={"button"}
                    className={"btn btn-success"}
                    style={{ height: 56, width: "49%", marginRight: "2%" }}
                    onClick={() => {
                      const address = formik.values.address.az;
                      if (address === "") {
                        toast.error(t("Сначала укажите адрес"));
                      } else {
                        axios
                          .get(
                            `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${process.env.REACT_APP_GOOGLE_MAP_KEY}`,
                          )
                          .then((response) => {
                            formik.setFieldValue(
                              "lat",
                              response.data?.results[0].geometry.location.lat,
                            );
                            formik.setFieldValue(
                              "lng",
                              response.data?.results[0].geometry.location.lng,
                            );
                          })
                          .catch((error) => toast.error(error.message));
                      }
                    }}
                  >
                    {t("Определить координати")}
                  </button>
                  <button
                    type={"button"}
                    className={"btn btn-warning"}
                    style={{ height: 56, width: "49%" }}
                    onClick={() => {
                      toggleModal(true);
                      loader
                        .load()
                        .then((google) => {
                          const map = new google.maps.Map(
                            document.getElementById("map"),
                            {
                              center: {
                                lat: Number(
                                  formik.values.lat === ""
                                    ? 40.401006011050455
                                    : formik.values.lat,
                                ),
                                lng: Number(
                                  formik.values.lng === ""
                                    ? 49.85458884979265
                                    : formik.values.lng,
                                ),
                              },
                              zoom: 16,
                            },
                          );
                          const draggableMarker = new google.maps.Marker({
                            position: {
                              lat: Number(
                                formik.values.lat === ""
                                  ? 40.401006011050455
                                  : formik.values.lat,
                              ),
                              lng: Number(
                                formik.values.lng === ""
                                  ? 49.85458884979265
                                  : formik.values.lng,
                              ),
                            },
                            map,
                            title: "Hello World!",
                            draggable: true,
                          });
                          // const draggableMarker =
                          //   new google.maps.AdvancedMarkerElement({
                          //     map,
                          //     position: {
                          //       lat: 40.401006011050455,
                          //       lng: 49.85458884979265,
                          //     },
                          //     gmpDraggable: true,
                          //     title: "This marker is draggable.",
                          //   });
                          //
                          draggableMarker.addListener("dragend", (event) => {
                            const position = draggableMarker.position;
                            formik.setFieldValue("lat", position.lat());
                            formik.setFieldValue("lng", position.lng());
                          });
                        })
                        .catch((e) => {
                          // do something
                        });
                    }}
                  >
                    {t("Указать на карте")}
                  </button>
                </Col>
                <Modal show={showModal}>
                  <Modal.Header closeButton onClick={() => toggleModal(false)}>
                    <Modal.Title>{t("Координаты")}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div id={"map"} style={{ width: "100%", height: 300 }} />
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="success"
                      onClick={() => formik.handleSubmit()}
                    >
                      {t("Сохранить")}
                    </Button>
                    <Button
                      variant="secondary"
                      onClick={() => toggleModal(false)}
                    >
                      {t("Закрыть")}
                    </Button>
                  </Modal.Footer>
                </Modal>
                <div className="col-md-6">
                  <Selected
                    label={"Тип"}
                    onChange={(value) => {
                      formik.setFieldValue(`type`, value);
                    }}
                    error={formik.errors.type}
                    name={"type"}
                    staticOptions={POINT_TYPE}
                    rows={{ value: "id", label: "name" }}
                    value={formik.values.type}
                    style={{ paddingRight: 0 }}
                  />
                </div>
                <div className="col-md-6">
                  <Selected
                    label={"Город"}
                    onChange={(value) => {
                      formik.setFieldValue(`city_id`, value);
                      getArea({
                        variables: {
                          city_id: Number(value),
                          lang: i18next.language,
                        },
                      })
                        .then((resp) => {
                          setArrArea(resp.data.areas);
                        })
                        .catch((error) => {
                          toast.error(error.message);
                        });
                    }}
                    error={formik.errors.city_id}
                    touched={formik.touched.city_id}
                    name={"city_id"}
                    remotePath={"/cities"}
                    modalForm={
                      <CityFormComponent
                        data={{
                          name: { ru: "", en: "", az: "" },
                          country_id: null,
                        }}
                        url={"/cities"}
                        onSuccess={() => {
                          Notification(t("Город создан"));
                        }}
                      />
                    }
                    staticOptions={arrCity}
                    rows={{ value: "id", label: "nameString" }}
                    value={formik.values.city_id}
                  />
                </div>
                <div className="col-md-6">
                  <Selected
                    label={"Район"}
                    onChange={(value) => {
                      formik.setFieldValue(`area_id`, value);
                    }}
                    error={formik.errors.area_id}
                    touched={formik.touched.area_id}
                    name={"area_id"}
                    staticOptions={arrArea}
                    rows={{ value: "id", label: "nameString" }}
                    value={formik.values.area_id}
                    style={{ paddingRight: 0 }}
                  />
                </div>
                <div className="col-md-12 text-center">
                  <Button
                    label={"Сохранить"}
                    loading={loading}
                    style={"btn btn-primary w-md"}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};
